import { render, staticRenderFns } from "./ModalFormularioProgramaUniversidadV2.vue?vue&type=template&id=f1a60ea6&scoped=true"
import script from "./ModalFormularioProgramaUniversidadV2.vue?vue&type=script&lang=js"
export * from "./ModalFormularioProgramaUniversidadV2.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioProgramaUniversidadV2.vue?vue&type=style&index=0&id=f1a60ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a60ea6",
  null
  
)

export default component.exports